import React, { PureComponent } from 'react'
import { Grid, ListItem } from '@material-ui/core'

import { connect } from 'react-redux'
import ContainerWithTitle from '../../HOC/ContainerWithTitle'
import ListContainer from '../../../components/common/ListContainer'
import { getTimecardsHistory, updateTimecard } from '../../../actions/employee'
import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
import TimeCardEditForm from '../../../components/Modal/TimeCardEditForm'
import ModalDialog from '../../../components/common/ModalDialog'
import { switchApp } from '../../../actions/auth'
import moment from 'moment'
import { EditableDateInput } from '../../../components/common/EditableComponents'

class TimeCards extends PureComponent {
  state = {
    selected: null,
    timeCardList: [],
    isValidDate: false,
  }

  componentDidMount() {
    this.props.dispatch(getTimecardsHistory())
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.employeeReducer &&
      nextProps.employeeReducer.timecardsHistory &&
      nextProps.employeeReducer.timecardsHistory.values &&
      nextProps.employeeReducer.timecardsHistory.values.length > 0
    ) {
      const timeCardData = nextProps.employeeReducer.timecardsHistory.values.map((timeCard) => {
        return {
          ...timeCard,
          id: timeCard && timeCard.timeCard && timeCard.timeCard.id,
          employee: `${timeCard.employee.firstName} ${timeCard.employee.lastName}`,
          role: timeCard.employee.role && timeCard.employee.role.name,
          clockedIn: this.usFormatDate(timeCard.timeCard.clockInTime),
          clockedOut: timeCard.timeCard.clockin
            ? 'Still Clocked in'
            : this.usFormatDate(timeCard.timeCard.clockOutTime),
          totalShift: timeCard.timeCard.clockin
            ? ''
            : this.momentDiff(
                timeCard.timeCard.clockInTime,
                timeCard.timeCard.clockOutTime,
                'HH:mm:ss',
              ),
        }
      })
      this.setState({
        timeCardList: timeCardData,
        building: true,
      })
    }
  }

  usFormatDate = (date) => {
    return moment(date).format('MM/DD/YYYY, h:mm A')
  }

  usFormatFilterDate = (date) => {
    return moment(date).format('MM/DD/YYYY')
  }

  validateDate = (date) => {
    return moment(date).isValid()
  }

  isValidDate(current) {
    return current <= moment()
  }

  momentDiff(start, end, formatDate) {
    let duration = moment.duration(moment(end).diff(moment(start)))
    return moment.utc(duration.as('milliseconds')).format(formatDate)
  }

  editTimeCard = (id) => {
    const { timecardsHistory = {} } = this.props.employeeReducer || {}
    const { values = [] } = timecardsHistory || {}
    const timeCard =
      values && values.length > 0 && values.find((timecard) => id === timecard.timeCard.id)

    if (timeCard) {
      this.timeCardModal.handleClickOpen()

      this.setState({
        selected: timeCard,
      })
    } else {
      return this.props.dispatch(openErrorMessage(`Timecard doesn't exist`))
    }
  }

  onSaveTimecard = () => {
    this.props.dispatch(updateTimecard(this.state.selected.timeCard)).then((res) => {
      if (res) {
        this.props.dispatch(openSuccessMessage(`Update timecard successfully`))
        this.props
          .dispatch(getTimecardsHistory())
          .then((timercard) => {
            const timeCardUpdated = this.getTimecardInitialData(timercard)
            this.setState({
              timeCardList: timeCardUpdated,
            })
          })
          .catch(function (error) {
            console.log('error', error)
          })
      }
      this.timeCardModal.handleClose()
    })
  }

  onChangeTimecard = (timecard) => {
    this.setState({
      selected: timecard,
    })
  }

  onSearch = (term) => {
    const { timecardsHistory = {} } = this.props.employeeReducer || {}
    const initialData = this.getTimecardInitialData(timecardsHistory)

    if (term) {
      const timeCardData =
        initialData.length > 0 &&
        initialData.filter((timeCard) => {
          return timeCard.employee.toLowerCase().includes(term.toLowerCase())
        })
      this.setState({
        timeCardList: timeCardData,
      })
    } else {
      this.setState({
        timeCardList: initialData,
      })
    }
  }

  onChangeTerm = (e) => {
    this.setState({ term: e.target.value })
  }

  goToReport = () => {
    let { session } = this.props.authReducer
    let { assignedShop } = session

    this.props
      .dispatch(switchApp({ appName: 'Retail', shopId: assignedShop.id }))
      .then((res) => {
        if (res) {
          const urlReport = `${res.redirectURL}/reports/details/?type=TIME_CLOCK_REPORTS`
          window.location.href = `${res.redirectURL}/login?token=${res.accessToken}&urlToRedirect=${urlReport}`
        }
      })
      .catch((err) => {})
  }

  getTimecardInitialData = (timecardsHistory) => {
    let { values = [] } = timecardsHistory || {}
    const timeCardData =
      values &&
      values.length > 0 &&
      values.map((timeCard) => {
        return {
          ...timeCard,
          id: timeCard && timeCard.timeCard && timeCard.timeCard.id,
          employee: `${timeCard.employee.firstName} ${timeCard.employee.lastName}`,
          role: timeCard.employee.role && timeCard.employee.role.name,
          clockedIn: this.usFormatDate(timeCard.timeCard.clockInTime),
          clockedOut: timeCard.timeCard.clockin
            ? 'Still Clocked in'
            : this.usFormatDate(timeCard.timeCard.clockOutTime),
          totalShift: timeCard.timeCard.clockin
            ? ''
            : this.momentDiff(
                timeCard.timeCard.clockInTime,
                timeCard.timeCard.clockOutTime,
                'HH:mm:ss',
              ),
        }
      })
    return timeCardData
  }

  onDateChange(value) {
    const filterDate = this.usFormatFilterDate(value)

    const { timecardsHistory = {} } = this.props.employeeReducer || {}
    const initialData = this.getTimecardInitialData(timecardsHistory)

    if (this.validateDate(value)) {
      const timeCardData =
        initialData.length > 0 &&
        initialData.filter((timeCard) => {
          return timeCard.clockedIn.includes(filterDate)
        })
      this.setState({
        timeCardList: timeCardData,
      })
    } else {
      this.setState({
        timeCardList: initialData,
      })
    }
  }

  render() {
    const timeCardColumns = [
      { id: 'employee', label: 'Employee' },
      { id: 'role', label: 'Role' },
      { id: 'clockedIn', label: 'Clocked In' },
      { id: 'clockedOut', label: 'Clocked Out' },
      { id: 'totalShift', label: 'Total Shift' },
      { id: 'action', label: '' },
    ]

    const { session } = this.props.authReducer
    const { assignedShop = {} } = session

    return (
      <div>
        <Grid container>
          <Grid className="addButton" item xs={12} sm={6} md={6} lg={6}>
            <h3>Timecards</h3>
          </Grid>
        </Grid>
        <ListItem>
          <Grid className="labelField" item xs={8} sm={8} md={8} lg={8}>
            <a className={'link-article'} href="javascript:void(0)" onClick={this.goToReport}>
              View Time Card Reports
            </a>
          </Grid>

          <Grid className="editField" item xs={4} sm={4} md={4} lg={4}>
            <EditableDateInput
              isValidDate={this.isValidDate}
              className="emp-date-picker"
              valueToRender={''}
              editMode={true}
              value={''}
              onChange={(date) => this.onDateChange(date)}
              type="text"
              dateFormat={'MM/DD/YYYY'}
              closeOnSelect={true}
              timeFormat={false}
              inputProps={{ placeholder: 'MM/DD/YYYY' }}
            />
          </Grid>
        </ListItem>

        <ListContainer
          columns={timeCardColumns}
          list={this.state.timeCardList || []}
          actionText={'Edit'}
          onClick={this.editTimeCard}
          onSearch={this.onSearch}
          onChangeTerm={this.onChangeTerm}
          term={this.state.term}
          hide={false}
          isSectionEmployees
        />
        <ModalDialog
          title={'Edit Timecard'}
          ref={(c) => (this.timeCardModal = c)}
          onConfirm={this.onSaveTimecard}
          onClose={this.onClose}
          onOpen={this.onOpen}
          paperStyle={{ maxWidth: '50%', minWidth: '50%', maxHeight: '70%', minHeight: '70%' }}
        >
          <TimeCardEditForm timecard={this.state.selected} onChange={this.onChangeTimecard} />
        </ModalDialog>
      </div>
    )
  }
}

export default connect((state) => ({
  dispatch: state.dispatch,
  authReducer: state.authReducer,
  employeeReducer: state.employeeReducer,
}))(ContainerWithTitle(TimeCards, 'Timecards'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Employees/TimeCards.js